<template>
    <div>
        <v-server-table ref="hseTypeTable" url="/admin/major-body-parts-list" :columns="columns" :options="options">

            <router-link slot="MajorBodyPartId" slot-scope="props" :to="`/incidents/settings/major-body-parts/edit/${props.row.MajorBodyPartId}`" title="Edit Major Body Part" class="btn btn-xs btn-secondary">
                Edit
            </router-link>

            <template slot="IsActive" slot-scope="props">
                <label :class="`text-${props.row.IsActive == 1 ? 'success' : 'danger'}`">
                    {{ props.row.IsActive == 1 ? 'Active' : 'Inactive' }}
                </label>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['MajorBodyPartId', 'BodyPartName', 'IsActive'],
                options: {
                    headings: {
                        MajorBodyPartId: 'Edit',
                        BodyPartName: 'Major Body Part',
                        IsActive: 'Status'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'majorbodypart.BodyPartName',
                    },
                    uniqueKey: 'MajorBodyPartId',
                },
            }
        }
    }
</script>
